import _classCallCheck from '../../../../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../../../../@babel/runtime/helpers/esm/createClass.js';
import _assertThisInitialized from '../../../../../@babel/runtime/helpers/esm/assertThisInitialized.js';
import _inherits from '../../../../../@babel/runtime/helpers/esm/inherits.js';
import _createSuper from '../../../../../@babel/runtime/helpers/esm/createSuper.js';
import _defineProperty from '../../../../../@babel/runtime/helpers/esm/defineProperty.js';
import { Parser } from '../Parser.js';
import { timezonePatterns } from '../constants.js';
import { parseTimezonePattern } from '../utils.js';

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);

export { ISOTimezoneWithZParser };
